import {
  CurecallModalContainer,
  CurecallButton,
  ECurecallButtonAppearance,
  ECurecallSize,
} from '@honestica/curecall-ui'
import { useState } from 'react'
import { TPatient } from 'src/types/patient'
import { getFullName } from 'src/utils/string-formatter.util'
import { useTranslation } from 'react-i18next'
import { getFormattedDate } from 'src/utils/date-formatter.util'
import PatientDocumentsList from './patient-documents-list.component'
import SendDocumentTab from './send-document-tab.component'

interface Props {
  isOpen: boolean
  patient: TPatient
  onToggle: () => void
}

const DocumentModal = ({ isOpen, onToggle, patient }: Props) => {
  const { t } = useTranslation()
  const [showListPage, setShowListPage] = useState(false)

  const handleChangePage = () => {
    setShowListPage((prev) => !prev)
  }

  const Title = (
    <div className="c-flex c-flex-row c-justify-between c-items-start">
      {showListPage ? (
        <div>{t('components.documents.documents-signed-by-patient')}</div>
      ) : (
        <div>
          {t('components.documents.send-an-electronic-signature-to')}
          <p>
            {t('components.documents.patient-name-and-birthday', {
              name: getFullName(patient),
              birthday: getFormattedDate(patient.birthdate),
            })}
          </p>
        </div>
      )}
      <CurecallButton
        appearance={ECurecallButtonAppearance['PRIMARY-OUTLINED']}
        size={ECurecallSize.SMALL}
        onClick={handleChangePage}
      >
        {showListPage
          ? t('components.documents.get-document-signed')
          : t('components.documents.signed-documents')}
      </CurecallButton>
    </div>
  )

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      title={Title}
      isOpen={isOpen}
      toggle={onToggle}
      dialogClassName="sm:c-w-[750px] xl:c-w-[900px]"
    >
      {showListPage ? <PatientDocumentsList /> : <SendDocumentTab onToggle={onToggle} />}
    </CurecallModalContainer>
  )
}

export default DocumentModal
